<template>
  <div class="card">
    <Box mb="4">
      <GradientIcon size="large" :name="iconName" />
    </Box>
    <Heading size="h5">
      {{ title }}
    </Heading>
    <Paragraph>
      {{ description }}
    </Paragraph>
    <a :href="linkUrl" class="card__link">
      <Icon name="ArrowRight" color="lightPurple" />
      {{ $t('pages.ssr_features.pages.common.more_features.learn_more') }}
    </a>
  </div>
</template>

<script>
import GradientIcon from '@/components/common/GradientIcon/GradientIcon'
import Heading from '@/components/common/Heading/Heading'
import Paragraph from '@/components/common/Paragraph/Paragraph'
import Box from '@/components/common/Box/Box'
import Icon from '@/components/common/Icon/Icon'

export default {
  components: {
    GradientIcon,
    Heading,
    Paragraph,
    Box,
    Icon
  },

  props: {
    iconName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    linkUrl: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  padding: $gap * 1.5;
  border-radius: $gap * 0.5;
  background-color: #201136;
  height: 100%;
  &__link {
    display: flex;
    align-items: center;
    gap: $gap * 0.5;
    margin-top: auto;
    color: $colorLightPurple;
    font-weight: 700;
    text-decoration: none;
    &:hover {
      color: $colorLightPurple;
    }
  }
}
</style>
